var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconType24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43572 2.46773C5.83862 1.739 6.88889 1.74678 7.28095 2.4814L10.6915 8.87193C11.0648 9.57135 10.558 10.4163 9.76521 10.4163H2.8214C2.02174 10.4163 1.51558 9.55807 1.9025 8.85826L5.43572 2.46773ZM6.34764 3.91844L3.5844 8.9163H9.01497L6.34764 3.91844Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7016 13.4348C21.9936 13.7286 21.9922 14.2035 21.6984 14.4955L14.6012 21.5502C14.3075 21.8422 13.8326 21.8407 13.5406 21.547C13.2486 21.2532 13.25 20.7783 13.5438 20.4863L20.6409 13.4316C20.9347 13.1396 21.4096 13.141 21.7016 13.4348Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7016 21.547C21.4096 21.8407 20.9347 21.8422 20.6409 21.5502L13.5438 14.4955C13.25 14.2035 13.2486 13.7286 13.5406 13.4348C13.8326 13.141 14.3075 13.1396 14.6012 13.4316L21.6984 20.4863C21.9922 20.7783 21.9936 21.2532 21.7016 21.547Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28832 20.2624C7.82706 20.2624 9.07445 19.015 9.07445 17.4762C9.07445 15.9375 7.82706 14.6901 6.28832 14.6901C4.74958 14.6901 3.50219 15.9375 3.50219 17.4762C3.50219 19.015 4.74958 20.2624 6.28832 20.2624ZM6.28832 21.7624C8.65549 21.7624 10.5745 19.8434 10.5745 17.4762C10.5745 15.1091 8.65549 13.1901 6.28832 13.1901C3.92116 13.1901 2.00219 15.1091 2.00219 17.4762C2.00219 19.8434 3.92116 21.7624 6.28832 21.7624Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.449 3.4284H14.8767V8.8864H20.449V3.4284ZM14.8767 1.9284C14.0483 1.9284 13.3767 2.59997 13.3767 3.4284V8.8864C13.3767 9.71483 14.0483 10.3864 14.8767 10.3864H20.449C21.2774 10.3864 21.949 9.71483 21.949 8.8864V3.4284C21.949 2.59997 21.2774 1.9284 20.449 1.9284H14.8767Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconType24);
export default __webpack_public_path__ + "static/media/icon_type_24.918339b6130e6333988a2bfca5bd8ced.svg";
export { ForwardRef as ReactComponent };